import { SearchLg } from "@untitledui/icons";
import { useSearchParams } from "react-router";
import { Button } from "@/components/base/buttons/button";
import { Input } from "@/components/base/input/input";

// A list's search term and position live in the URL (?q=&offset=): the loader reads them, so a
// reload or a shared link shows the same rows, and Back undoes a search.

export function SearchBox({ label }: { label: string }) {
  const [params, setParams] = useSearchParams();
  return (
    <form
      role="search"
      className="max-w-sm"
      onSubmit={(e) => {
        e.preventDefault();
        const q = String(new FormData(e.currentTarget).get("q") ?? "").trim();
        setParams(q ? { q } : {});
      }}
    >
      <Input key={params.get("q") ?? ""} name="q" type="search" aria-label={label} placeholder={`${label}，回车确认`} icon={SearchLg} defaultValue={params.get("q") ?? ""} />
    </form>
  );
}

export function Pager({ total, offset, limit }: { total: number; offset: number; limit: number }) {
  const [params, setParams] = useSearchParams();
  const go = (next: number) => {
    const p = new URLSearchParams(params);
    if (next > 0) p.set("offset", String(next));
    else p.delete("offset");
    setParams(p);
  };
  if (total <= limit) return <p className="text-sm text-tertiary">共 {total} 条</p>;
  return (
    <div className="flex items-center justify-between gap-3">
      <p className="text-sm text-tertiary">
        第 {offset + 1}–{Math.min(offset + limit, total)} 条，共 {total} 条
      </p>
      <div className="flex gap-3">
        <Button color="secondary" size="sm" isDisabled={offset === 0} onClick={() => go(Math.max(0, offset - limit))}>
          上一页
        </Button>
        <Button color="secondary" size="sm" isDisabled={offset + limit >= total} onClick={() => go(offset + limit)}>
          下一页
        </Button>
      </div>
    </div>
  );
}
